import Button from 'v3/common/components/Button';
import AlgoverseDeploymentCostAlert from '../DeploymentCostAlert';
import AlgoverseInsufficientBalanceAlert from '../InsufficientBalanceAlert';
import { DEPLOYMENT_STATUS, AlgoverseDeploymentCostModalProps } from './types.type';

export const getModalConfig = ({
  status,
  isPremium,
  onClose,
  onSave,
}: Omit<AlgoverseDeploymentCostModalProps, 'isOpen'> & { status: DEPLOYMENT_STATUS }) => {
  return {
    [DEPLOYMENT_STATUS.LOADING]: {
      title: 'Checking Authorization...',
      body: (
        <div className="d-flex justify-content-center align-items-center p-5">
          <div className="spinner-border text-primary" />
        </div>
      ),
      footer: (
        <>
          <Button className="btn btn-outline-primary close" onClick={onClose}>
            Cancel
          </Button>
          <button className="btn btn-primary" disabled>
            Proceed
          </button>
        </>
      ),
    },

    [DEPLOYMENT_STATUS.CONFIRMATION]: {
      title: 'Deployment Charges',
      body: <AlgoverseDeploymentCostAlert variant="alert" isPremium={isPremium} />,
      footer: (
        <>
          <Button className="btn btn-outline-primary close" onClick={onClose}>
            Close
          </Button>
          <Button className="btn btn-primary" onClick={onSave}>
            Proceed
          </Button>
        </>
      ),
    },

    [DEPLOYMENT_STATUS.INSUFFICIENT_FUNDS]: {
      title: 'Insufficient Funds',
      body: <AlgoverseInsufficientBalanceAlert />,
      footer: (
        <>
          <Button className="btn btn-outline-primary close" onClick={onClose}>
            Close
          </Button>
          <Button
            className="btn btn-primary"
            onClick={() => {
              onClose();
              window.open('https://pro.upstox.com/funds/securities/wallet', '_blank');
            }}
          >
            Add Funds
          </Button>
        </>
      ),
    },
  }[status];
};
